<!-- <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.5.10/webfont.js"></script> -->
<script>
	//$( document ).ready(function() {
	//WebFont.load({
	// custom: {
	//	families: ['Cinzel', 'Pinyon Script']
	//  }
	//});
	//});
</script>
<div class="wrapper" id="certificate" *ngIf="!honor_roll">
	<div class="content">
		<div class="line top"></div>
		<div class="line top2"></div>
		<div class="topheader wrap">
			<div class="innerwrap">
				<img [src]="'/app/aw-ui-angular/assets/custom/abmc/img/header.jpg'" />
			</div>
		</div>
		<div class="region region-content">
			<div class="views-element-container">
				<div
					class="view view-memorial-certificate view-id-memorial_certificate view-display-id-page_1 js-view-dom-id-ce759b3072d5bcf0627e6f2569444c7967be9118ed86523db21024447070e3a2">
					<div class="view-content">
						<div class="views-row">
							<div class="name wrap">
								<h1>{{fullRecordMetadata['first_name']}} {{fullRecordMetadata['middle_name']}}
									{{fullRecordMetadata['title']}}</h1>
							</div>
							<div class="rank wrap">
								<h2>Rank</h2>
								<div>{{fullRecordMetadata['military_rank']}}, {{fullRecordMetadata['branch']}}</div>
							</div>
							<div class="unit wrap">
								<h2>Unit</h2>
								<div>{{fullRecordMetadata['unit']}}{{fullRecordMetadata['division'] ? ', ' +
									fullRecordMetadata['division'] : ''}}</div>
							</div>
							<div class="ddate wrap">
								<h2>Date of Death</h2>
								<div>{{fullRecordMetadata['death_date']}}</div>
							</div>
							<div class="cem wrap">
								<h2>Commemorated in perpetuity at</h2>
								<div>{{fullRecordMetadata['cemetery']}}<div class="location">
										{{fullRecordMetadata['cemetery_location']}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="seal wrap">
			<div class="innerwrap">
				<img [src]="'/app/aw-ui-angular/assets/custom/abmc/img/seal.jpg'" />
			</div>
		</div>
		<div class="line bottom"></div>
		<div class="line bottom2"></div>
	</div>
</div>
<div id="honor_roll_certificate" *ngIf="honor_roll">
	<div class="smallBorder">
		<div class="container"> 
			<div class="header_container">
				<div class="graphics_container">
					<img alt="Border Top Left" class="border left" [src]="'/app/aw-ui-angular/assets/custom/abmc/img/decedent_print/k-corner-top-left.png'"/>
					<img alt="Banner" class="banner banner-container" [src]="'/app/aw-ui-angular/assets/custom/abmc/img/decedent_print/k-header.png'"/>
					<img alt="Border Top Right" class="border right" [src]="'/app/aw-ui-angular/assets/custom/abmc/img/decedent_print/k-corner-top-right.png'"/>
				</div>
				<div class="actual_header text_container"></div>
			</div>
			<div class="deceased_container">
				<div class="deceased">
					<span>
						{{fullRecordMetadata['first_name']}} {{fullRecordMetadata['middle_name']}} {{fullRecordMetadata['title']}}
					</span>
				</div>
				<div class="information_frame">
					<div class="info-container">
						<div class="label">RANK</div>
						<div class="description">
							{{fullRecordMetadata['military_rank']}}, {{fullRecordMetadata['branch']}}
						</div>
					</div>
					<div class="info-container">
						<div class="label">DATE OF DEATH</div>
						<div class="description">
							{{fullRecordMetadata['death_date']}}
						</div>
					</div>
				</div>
			</div>
			<div class="footer_container">
				<div class="footer_text_container">
					{{fullRecordMetadata['notes']}}
				</div>
				<div class="graphics_container">
					<img alt="Border Bottom Left" class="border left" [src]="'/app/aw-ui-angular/assets/custom/abmc/img/decedent_print/k-corner-bottom-left.png'"/>
					<div class="banner-container">
					</div>
					<img alt="Border Bottom Right" class="border right" [src]="'/app/aw-ui-angular/assets/custom/abmc/img/decedent_print/k-corner-bottom-right.png'"/>
				</div>
			</div>
		</div>
	</div>
</div>
